module.exports = __webpack_public_path__ + "labioplastika_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_5_before.jpg
// module id = 1076
// module chunks = 0